module.exports = __webpack_public_path__ + "img/thumbnail_Siamang_j_normal.227f3559.png";